<template>
  <li class="dropdown_menu" :class="mainTagListCssObj">
    <a v-b-toggle.courseCompleteCollapse>
      <i class="bi bi-clipboard-check-fill"></i>
      <span class="link-title menu_hide"> อนุมัติการจบคอร์ส</span>
      <span class="fa arrow menu_hide"></span>
    </a>
    <b-collapse
      id="courseCompleteCollapse"
      :visible="false"
      accordion="accordion"
    >
      <MainCollapseMenu :collapse-list="collapseList" :is-active="!isActive" />
    </b-collapse>
  </li>
</template>

<script>
import _ from "lodash";
import MainCollapseMenu from "@/components/layouts/sidebars/collapse-menu/MainCollapseMenu.vue";
import authMixin from "@/mixins/auth-mixin.js";
import { checkSubMenuAccess } from "../../../../services/accessControl";

export default {
  components: { MainCollapseMenu },
  mixins: [authMixin],
  data() {
    return {
      isActive: false,
      collapseList: [],
    };
  },
  computed: {
    mainTagListCssObj() {
      return {
        active: this.isActive,
      };
    },
  },
  mounted() {
    if (
      checkSubMenuAccess(
        { menu: "course-complete-approval" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "อนุมัติการจบคอร์ส",
        to: { name: "course.complete.list" },
      });
    }
  },
  methods: {
    checkActiveRoute() {
      const useModuleMetaMatcher = !!this.$route.meta.module;
      this.isActive = _.includes(
        _.map(this.collapseList, (ech) => {
          if (!!ech.meta && !!ech.meta.module) {
            return ech.meta.module;
          }
          return ech.to.name;
        }),
        useModuleMetaMatcher ? this.$route.meta.module : this.$route.name
      );
    },
  },
};
</script>
